/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'cvlib';
import './PasswordForm.scss';
import { useSelector } from 'react-redux';
import { getClaroAdsKey } from 'utils/claroAds/getClaroAdskey';

const PasswordForm = props => {
  const {
    login_password_title_label,
    login_password_description_label,
    login_password_option_button_cancel,
    login_password_option_button_next,
    password_tooltip_completeField_label_validation,
    login_password_option_button_passwordRecovery,
  } = props.translations;

  const {
    onNextClicked,
    onCancelClicked,
    onPasswordRecoveryClicked,
    isLoading,
    error,
  } = props;

  const [errorMessage, setErrorMessage] = useState(null);
  const [passwordValue, setPasswordValue] = useState('');
  const claroAdEnable = useSelector(state => getClaroAdsKey(state));

  useEffect(
    () => {
      if (errorMessage !== null && error && error?.code) {
        setErrorMessage(props.translations[error?.code]);
        //setErrorMessage(error?.error?.[0]);
      }
    },
    [error],
  );
  const satisfyPassword = pass => pass.length > 0;
  const elements = [
    {
      element: 'title',
      content: login_password_title_label,
      expand: claroAdEnable ? 1.6 : 0.6,
      ...(claroAdEnable ? { className:'title-margin'} : {})
    },
    {
      element: 'subtitle',
      content: login_password_description_label,
      position: 'top',
      expand: claroAdEnable ? 0.01 : 0.2,
      ...(claroAdEnable ? { className:'subtitle-margin'} : {})
    },
    {
      element: 'item',
      type: 'password',
      name: 'password',
      id: 'password',
      autoFocus: true,
      error: errorMessage,
      expand: claroAdEnable ? 0.01 : 3,
      defaultVisible: false,
      rules: [],
      position: 'center',
      registerOptions: {
        required: password_tooltip_completeField_label_validation,
      },
      onChange: ({ target }) => {
        setPasswordValue(target.value);
        setErrorMessage('');
      },
      onKeyUp: ({ keyCode }) => {
        if (keyCode === 13) {
          const submitButton = document.getElementById('submitPassword');
          submitButton.click();
        }
      },
      clearOtherErrors: () => setErrorMessage(''),
    },
    {
      element: 'button',
      type: 'red',
      ...(claroAdEnable ? { className:'password-margin'} : {}),
      content: login_password_option_button_next,
      submit: onNextClicked,
      disabled: isLoading,
      dimmed: !satisfyPassword(passwordValue),
      expand: claroAdEnable ? 0.01 : 0.7,
      id: 'submitPassword',
    },
    {
      element: 'button',
      type: 'gray',
      ...(claroAdEnable ? { className:'cancel-margin'} : {}),
      content: login_password_option_button_cancel,
      onClick: onCancelClicked,
      expand: claroAdEnable ? 0.01 : 1.1,
      disabled: isLoading,
    },
    {
      element: 'button',
      type: 'gray',
      ...(claroAdEnable ? { className:'forgotpass-margin'} : {}),
      content: login_password_option_button_passwordRecovery,
      onClick: onPasswordRecoveryClicked,
      disabled: isLoading,
      expand: claroAdEnable ? 0.01 : 0.9,
    },
  ];
  return <Form elements={elements} />;
};

PasswordForm.propTypes = {
  onCancelClicked: PropTypes.func,
  onNextClicked: PropTypes.func,
  onPasswordRecoveryClicked: PropTypes.func,
  isLoading: PropTypes.bool,
  error: PropTypes.shape({}),
  translations: PropTypes.shape({
    login_password_title_label: PropTypes.string,
    login_password_description_label: PropTypes.string,
    login_password_option_button_next: PropTypes.string,
    login_password_option_button_cancel: PropTypes.string,
    password_tooltip_letter_label_validation: PropTypes.string,
    password_tooltip_number_label_validation: PropTypes.string,
    password_tooltip_length_label_validation: PropTypes.string,
  }),
};

export default PasswordForm;
